import { IGetControleEnergiaByIdUseCase } from "../../../presentation/useCases/read/get_controle_energia_by_id_use_case";
import { GetControleEnergiaByIdRequestModel, GetControleEnergiaByIdResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetControleEnergiaByIdUseCase
 */

export class GetControleEnergiaByIdUseCase implements IGetControleEnergiaByIdUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async getControleEnergiaById(model: GetControleEnergiaByIdRequestModel): Promise<GetControleEnergiaByIdResponseModel> {
    return await this.repository.getControleEnergiaById(model);
  }
}
